import { render, staticRenderFns } from "./DownloadModal.vue?vue&type=template&id=1761bc20&"
import script from "./DownloadModal.vue?vue&type=script&lang=js&"
export * from "./DownloadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports